import React, { useCallback, useEffect, useState } from "react";
import {
    collection,
    getDocs,
    deleteDoc,
    doc
} from "firebase/firestore";

import { useParams } from "react-router-dom";
import { db } from "../../firebase/firebase";

import "../../assets/css/admin/managePhotos.css";

function ManagePhotos() {

    const { category } = useParams();

    const [photos, setPhotos] = useState([]);
    const [loading, setLoading] = useState(true);

    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

const [selectedPhotoId, setSelectedPhotoId] = useState(null);

    const loadPhotos = useCallback(async () => {

        try {

            setLoading(true);

            const data = [];

            const snapshot = await getDocs(
                collection(db, "photos")
            );

            snapshot.forEach((itemDoc) => {

                const item = {

                    id: itemDoc.id,
                    ...itemDoc.data()

                };

                if (
                    category === "All" ||
                    item.category === category
                ) {

                    data.push(item);

                }

            });

            setPhotos(data);

        }

        catch (error) {

            console.log(error);

        }

        finally {

            setLoading(false);

        }

    }, [category]);



    useEffect(() => {

        loadPhotos();

    }, [loadPhotos]);



    const deletePhoto = (id) => {

    setSelectedPhotoId(id);

    setShowDeleteModal(true);

};
const confirmDeletePhoto = async () => {

    try {

        await deleteDoc(

            doc(
                db,
                "photos",
                selectedPhotoId
            )

        );

        setShowDeleteModal(false);

        setSelectedPhotoId(null);

        loadPhotos();

    }

    catch (error) {

        console.log(error);

        setShowDeleteModal(false);

    }

};



    if (loading) {

        return (

            <div className="manage-gallery">

                <h2>Loading Photos...</h2>

            </div>

        );

    }



    return (
        <>
        {showDeleteModal && (

    <div className="delete-overlay">

        <div className="delete-modal">

            <h2>

                Delete Photo?

            </h2>

            <p>

                Are you sure you want to delete this photo?

                <br /><br />

                This action cannot be undone.

            </p>

            <div className="delete-actions">

                <button
                    className="cancel-btn"
                    onClick={() => {

                        setShowDeleteModal(false);

                        setSelectedPhotoId(null);

                    }}
                >

                    Cancel

                </button>

                <button
                    className="confirm-btn"
                    onClick={confirmDeletePhoto}
                >

                    Delete

                </button>

            </div>

        </div>

    </div>

)}

        <div className="photo-manage-gallery">

    <div className="photo-manage-header">

        <h1>{category} Photos</h1>

    </div>

    {
        photos.length === 0 ?

        (

            <div className="photo-empty-box">

                <h2>No Images Found</h2>

            </div>

        )

        :

        (

            <div className="photo-gallery-grid">

                {

                    photos.map((photo)=>(

                        <div
                            className="photo-gallery-card"
                            key={photo.id}
                        >

                            <img
                                src={photo.imageUrl}
                                alt={photo.title}
                                className="photo-gallery-image"
                            />

                            <div className="photo-gallery-content">

                                <h3>{photo.title}</h3>

                                <div className="photo-gallery-buttons">

                                    <button
                                        className="photo-view-btn"
                                        onClick={() => setSelectedPhoto(photo)}
                                    >
                                        View
                                    </button>

                                    <button
                                        className="photo-delete-btn"
                                        onClick={() => deletePhoto(photo.id)}
                                    >
                                        Delete
                                    </button>

                                </div>

                            </div>

                        </div>

                    ))

                }

            </div>

        )

    }

    {

        selectedPhoto && (

            <div
                className="photo-image-modal"
                onClick={() => setSelectedPhoto(null)}
            >

                <div
                    className="photo-modal-content"
                    onClick={(e)=>e.stopPropagation()}
                >

                    <button
                        className="photo-modal-close"
                        onClick={() => setSelectedPhoto(null)}
                    >
                        ×
                    </button>

                    <img
                        src={selectedPhoto.imageUrl}
                        alt={selectedPhoto.title}
                    />

                    <h2>{selectedPhoto.title}</h2>

                </div>

            </div>

        )

    }

</div>
</>
    );

}

export default ManagePhotos;